import type { Persona } from "@/schema/quizSchema";
import { useStrings } from "@/i18n/LocaleContext";
import { safeHref } from "@/lib/safeUrl";

export function ResultScreen({
  persona,
  onCtaClick,
}: {
  persona: Persona;
  /** Analytics hook fired when the result CTA is clicked (link still opens). */
  onCtaClick?: () => void;
}) {
  const t = useStrings();
  return (
    <div>
      <p style={{ color: "var(--color-accent)", fontWeight: 600, margin: "0 0 0.25rem" }}>{t.yourResult}</p>
      <h2 style={{ fontFamily: "var(--font-title)", fontSize: "var(--type-result-title)", lineHeight: "var(--leading-title)", margin: "0 0 0.5rem" }}>
        {persona.label}
      </h2>
      <p style={{ fontSize: "var(--type-result-tagline)", color: "var(--color-ink)", margin: "0 0 1rem" }}>
        {persona.result.tagline}
      </p>
      {persona.result.body.map((line, i) => (
        <p key={i} style={{ color: "var(--color-muted)", margin: "0 0 0.5rem" }}>
          {line}
        </p>
      ))}
      {persona.result.cta && (
        <a
          href={safeHref(persona.result.cta.href)}
          target="_blank"
          rel="noopener noreferrer"
          className="qk-cta"
          onClick={onCtaClick}
        >
          {persona.result.cta.label}
        </a>
      )}
    </div>
  );
}
